module.exports = __webpack_public_path__ + "static/img/pic_zrdaoshi_zm@2x.e939050d.png";